import React from 'react'
import { styled } from '@mui/system'
import { CardHeader, Grid } from '@mui/material'
import { TextField, DateField } from '../../../../../ui'
import { generateUtilityClasses } from '@mui/material'

const classes = generateUtilityClasses('Grid', ['root', 'row'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
}))

interface Props {}

export const FloorplanForm = ({}: Props) => {
  return (
    <>
      <CardHeader title='Floorplan' />
      <Grid container spacing={2} p={3}>
        <Grid item xs={6}>
          <TextField name='floorplanVendorName' disabled label='Floorplan Vendor' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={6}>
          <TextField name='floorplanType' disabled label='Floorplan Type' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={6}>
          <TextField name='floorplanInterestRate' label='Interest Rate (%)' fullWidth required />
        </Grid>
        <Grid item xs={6}>
          <DateField name='floorplanDate' disabled label='Floor Date' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <DateField name='floorplanLastPaidDate' disabled label='Last Paid Date' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <DateField name='floorplanNextDueDate' disabled label='Next Due Date' fullWidth />
        </Grid>
      </Grid>
    </>
  )
}

export default FloorplanForm
